import { type ActionContext } from 'vuex'

import { type CoreModule } from '@/lib/store/types'

import {
  type BlockCore,
  type BuilderState,
  type ResourceCore,
} from '../../types'

export const blockDelete = async <
  TResource extends ResourceCore,
  TBlock extends BlockCore,
>(
  {
    state,
    commit,
    dispatch,
  }: ActionContext<BuilderState<TResource, TBlock>, CoreModule>,
  blockId: string
): Promise<void> => {
  commit('_builder_BLOCK_DELETE', blockId)
}
